export default function formatNumber(input: number | string) {
  const formattedNumber = Number(input).toFixed(2);

  return formattedNumber.replace(/(.00)$/, '');
}
